/*
 * @Author: Claire Cheng
 * @Date: 2023-12-11 18:44:32
 * @LastEditors: Claire Cheng
 * @LastEditTime: 2023-12-26 14:31:22
 * @Description: file content
 */
import { ThemeOptions } from '@mui/material';

// Colors

const neutral = {
  100: '#fafafa', // --awsui-color-grey-100
  200: '#eaeded', // --awsui-color-grey-200
  300: '#d5dbdb', // --awsui-color-grey-300
  400: '#aab7b8', // --awsui-color-grey-400
  500: '#879596', // --awsui-color-grey-500
  600: '#545b64', // --awsui-color-grey-600
  700: '#2a2e33', // --awsui-color-grey-700
  800: '#1a2029', // --awsui-color-grey-800
  900: '#16191f', // --awsui-color-grey-900
};

const background = {
  default: '#16191f',
  paper: '#2a2e33',
};

const primary = {
  main: '#44b9d6',
  contrastText: '#fff',
};

const secondary = {
  main: '#6aaf35',
  contrastText: neutral[900],
};

export const darkThemeOptions: ThemeOptions = {
  components: {
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#0A84FF',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02))',
        },
      },
    },
  },
  palette: {
    background,
    mode: 'dark',
    primary,
    secondary,
  },
  diseaseGroupsColors: {
    IBD: {
      main: '#ab1a78',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    TCB: {
      main: '#0F4392',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    'TCB-F': {
      main: '#e76500',
      light: '',
      dark: '',
      contrastText: '#e76500',
    },
    SBS: {
      main: '#007749',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    ALF: {
      main: '#1B90FF',
      light: '',
      dark: '',
      contrastText: '#1B90FF',
    },
    RH: {
      main: '#E1242A',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    RI: {
      main: '#891515',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    RM: {
      main: '#A1A4AC',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    PDT: {
      main: '#F78C85',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    'CRC(VCT・FRU)': {
      main: '#00A1D4',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    NIN: {
      main: '#E47700',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    ADC: {
      main: '#BF1A42',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    ALB: {
      main: '#37A2B3',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    CAB: {
      main: '#1B568A',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    OC: {
      main: '#123B73',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    Vaccine: {
      main: '#DF5426',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
  },
};
